import React from 'react';
import getContent from '../lib/dictionaryFetcher';

const EmptyFavoritesTab = () => (
  <div id="noFavoriteMessage">
    {getContent('merchanthub', 'tools.favorites.nofavorite', '')}
  </div>
);

export default EmptyFavoritesTab;
